import React, { useMemo } from 'react';
import CompositePlatformField from '../../components/CompositePlatformField';

interface PlatformCPMCellProps {
  /** 商单平台CPM数据（ItemVo 数组） */
  starMapCPMList?: any[];
  /** 供应商CPM数据（ItemVo 数组） */
  supplierCPMList?: any[];
  /** 主平台报价项目（用于决定显示逻辑） */
  quoteProject?: string;
  /** 是否展示数据切换按钮 */
  showRadioGroup?: boolean;
}

/**
 * 平台CPM信息展示组件
 * 使用 CompositePlatformField 实现复合字段逻辑
 */
const PlatformCPMCell: React.FC<PlatformCPMCellProps> = ({
  starMapCPMList = [],
  supplierCPMList = [],
  quoteProject,
  showRadioGroup = true,
}) => {
  // 转换为 CompositePlatformField 需要的格式
  // ItemVo 的 value 是一个对象，需要提取实际数值
  const starMapData = useMemo(() => starMapCPMList.map((item) => ({
    type: item.name || '',
    value: item.value,
  })), [starMapCPMList]);

  const supplierData = useMemo(() => supplierCPMList.map((item) => ({
    type: item.name || '',
    value: item.value,
  })), [supplierCPMList]);

  return (
    <CompositePlatformField
      starMapData={starMapData}
      supplierData={supplierData}
      quoteProject={quoteProject}
      showRadioGroup={showRadioGroup}
    />
  );
};

export default PlatformCPMCell;
